<template>
  <div class="m-home-page">
    <div class="header-wrap">
      <m-base-swiper :list="bannerList"></m-base-swiper>
    </div>
    <div class="main">
      <m-base-title title="业务领域" richTitle="business"></m-base-title>
      <div class="business-content app-flex-mid-center">
        <div class="business-item app-flex-mid-center" v-for="item in areaList" :key="item.id">
          <template v-if="item.title || item.desc">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </template>
          <template v-else>
            <img :src="item.url" class="desc-img" />
          </template>
        </div>
      </div>

      <m-base-title title="关于我们" richTitle="about us"></m-base-title>
      <div class="about-content">
        <img src="../../../assets/about.png" class="about-img" />
        <div class="about-desc">四川宏博腾科技有限公司系一家民营高科技企业，专业从事工业设备、工业自控系统研发、工业视觉系统研发、教育信息系统的销售和售后服务。</div>
      </div>

      <m-base-title title="合作客户" richTitle="cooperative client"></m-base-title>
      <m-base-custom class="cooperative-cont"></m-base-custom>
    </div>

    <m-base-foot></m-base-foot>
  </div>
</template>

<script>
import MBaseSwiper from '../components/MBaseSwiper.vue'
import MBaseFoot from '../components/MBaseFoot.vue'
import MBaseTitle from '../components/MBaseTitle.vue'
import MBaseCustom from '../components/MBaseCustom.vue'

export default {
  components: {
    MBaseFoot,
    MBaseSwiper,
    MBaseTitle,
    MBaseCustom
  },
  data() {
    return {
      // banner 列表
      bannerList: [
        {
          id: 0,
          url: require('../../../assets/m-banner/1.png')
        },
        {
          id: 1,
          url: require('../../../assets/m-banner/2.png')
        },
        {
          id: 2,
          url: require('../../../assets/m-banner/3.png')
        },
        {
          id: 3,
          url: require('../../../assets/m-banner/4.png')
        },
        {
          id: 4,
          rich: '智控系统，一键触达',
          url: require('../../../assets/m-banner/5.png')
        },
        {
          id: 5,
          rich: '智能管理，教育信息化',
          url: require('../../../assets/m-banner/6.png')
        }
      ],
      // 领域列表
      areaList: [
        {
          id: 0,
          title: '工业产品',
          desc: '空压机、制氮机、制氧机、阀门、滤芯等专业供应商'
        },
        {
          id: 1,
          url: require('../../../assets/business/1.png')
        },
        {
          id: 3,
          url: require('../../../assets/business/2.png')
        },
        {
          id: 2,
          title: '智能视觉',
          desc: '集光，机，电，软，算为一体应用于多个行业'
        },
        {
          id: 5,
          title: '自控系统',
          desc: '规划设计、系统集成、软件开发设计、系统（非标）定制、电气控制系统开发...'
        },
        {
          id: 4,
          url: require('../../../assets/business/3.png')
        },
        {
          id: 6,
          url: require('../../../assets/business/4.png')
        },
        {
          id: 7,
          title: '教育信息化',
          desc: '专业提供职教领域教育信息化建设及教学仪器设备整体解决方案。'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.m-home-page {
  background: linear-gradient(180deg, #d3e5f7 0%, #ffffff 15%);
  .main {
    padding: 0px 20px 50px;
    .business-content {
      flex-wrap: wrap;
      margin-top: 20px;
      .business-item {
        width: 160px;
        height: 160px;
        flex-direction: column;
        background-color: rgba(0, 0, 0, 0.05);
        user-select: none;
        transition: all 0.3s;
        &:nth-child(1),
        &:nth-child(4),
        &:nth-child(5),
        &:nth-child(8) {
          background-color: #c5dbec;
        }
        &:not(:nth-child(2n)) {
          margin-right: 15px;
        }
        &:not(:nth-child(-n + 2)) {
          margin-top: 15px;
        }
        // &:hover {
        //   transform: scale(1.01);
        //   box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.2);
        // }
        .title {
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #eb543c;
          line-height: 23px;
        }
        .desc {
          max-width: 115px;
          margin-top: 10px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #63676a;
          line-height: 17px;
          text-align: center;
        }
        .desc-img {
          height: inherit;
          width: inherit;
        }
      }
    }

    .about-content {
      margin-top: 20px;
      background-color: #e2edf6;
      .about-img {
        width: 100%;
        height: auto;
      }
      .about-desc {
        padding: 8px 10px;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000;
        line-height: 22px;
        user-select: none;
        text-indent: 22px;
        word-break: break-all;
      }
    }

    .cooperative-cont {
      margin-top: 20px;
    }
  }
}
</style>
